import { GetLocalState } from "Connectivity/LocalStorage";
import Cookies from "js-cookie";

export const AssetReplacer = (path:string, addClientToPath = false) => {

  if ( !path || path === undefined ) return "";

  const CLIENT  = GetLocalState("settings").Client;
  const CDN     = GetLocalState("settings").paths.CDN;
  const THEME   = Cookies.get("web-theme");
  
  if ( !path ) return "";
  
  if ( path.includes("[[CDN_ROOT]]") && addClientToPath ) {
    const replaceText = addClientToPath ? CDN + "/" + CLIENT : CDN;
    path = path.replace('[[CDN_ROOT]]', replaceText);
  }
  else {
    path = path.replace('[[CDN_ROOT]]', CDN);
  }
  
  if ( THEME !== "" && typeof THEME === "string" ) {
    path = path.replace('[[THEME]]', THEME);
  }

  return path;

}